<template>
  <div
    v-if="Object.keys(summaryTotal).length && Object.keys(proceso).length"
    class="container"
  >
    <div class="columns">
      <!--   Tooltip   -->
      <div
        v-if="!generalContext.status"
        class="column"
        :class="generalContext.status ? 'is-0' : ''"
      >
        <div
          v-if="generalContext && !generalContext.status"
          style="position: absolute; width: 23%; border-radius: 6px; background-color: rgba(0,0,0,0.6)"
          class="has-text-white has-text-left "
        >
          <div id="bodyInterAct">
            <h1 id="titleInterAct" class="has-text-weight-bold"></h1>
            <p id="textInterAct" style="font-size: 12px"></p>
          </div>
        </div>
      </div>
      <!--   Table of General Information  -->
      <div
        class="column is-justify-center is-flex"
        style="transition: all 1s"
        :class="generalContext.status ? 'is-6' : 'is-8'"
      >
        <table class="table-general is-full">
          <tr>
            <td colspan="4" class="has-text-centered is-size-3">
              <div
                :class="
                  `rango${rangos(summary.total ? summary.total.CClimad.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h1 class="has-text-weight-bold" style="padding: 1.5rem;">
                    Clima total.
                    <span>
                      {{
                        nombrerangos[
                          rangos(summary.total ? summary.total.CClimad.p : 0)
                        ]
                      }}
                    </span>
                    {{
                      summary.total ? summary.total.CClimad.p : 0 | number1(1)
                    }}%
                  </h1>
                  <direction-indicator
                    v-if="summary.processComp"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="CClimad"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="is-size-5 has-text-centered">
              <div
                :class="
                  `rango${rangos(summary.total ? summary.total.apoyod.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h1 class="w-full">
                    Apoyo <br class="is-hidden-desktop" />
                    {{
                      summary.total ? summary.total.apoyod.p : 0 | number1(1)
                    }}%
                  </h1>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="25"
                    :h="25"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="apoyod"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
            <td colspan="2" class="is-size-5 has-text-centered">
              <div
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.innovaciond.p : 0
                  )}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h1 class="w-full">
                    Innovación <br class="is-hidden-desktop" />
                    {{
                      summary.total
                        ? summary.total.innovaciond.p
                        : 0 | number1(1)
                    }}%
                  </h1>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="25"
                    :h="25"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="innovaciond"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="is-size-5 has-text-centered">
              <div
                :class="
                  `rango${rangos(summary.total ? summary.total.calidadd.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h1 class="w-full">
                    Calidad <br class="is-hidden-desktop" />
                    {{
                      summary.total ? summary.total.calidadd.p : 0 | number1(1)
                    }}%
                  </h1>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="25"
                    :h="25"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="calidadd"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
            <td colspan="2" class="is-size-5 has-text-centered">
              <div
                :class="
                  `rango${rangos(summary.total ? summary.total.metasd.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h1 class="w-full">
                    Metas <br class="is-hidden-desktop" />
                    {{
                      summary.total ? summary.total.metasd.p : 0 | number1(1)
                    }}%
                  </h1>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="25"
                    :h="25"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="metasd"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
          </tr>
          <!--     Desktop     -->
          <tr>
            <!--      Desktop      -->
            <td class="is-size-6 has-text-centered is-hidden-mobile">
              <div
                v-on:mouseover="
                  textInter(
                    'dimenc',
                    'lidd',
                    summary.total ? summary.total.lidd.p : 0
                  )
                "
                v-on:mouseout="textClear()"
                :class="
                  `rango${rangos(summary.total ? summary.total.lidd.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h2 class="w-full">Liderazgo</h2>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="20"
                    :h="20"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="lidd"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
            <td class="is-size-6 has-text-centered is-hidden-mobile">
              <div
                v-on:mouseover="
                  textInter(
                    'dimenc',
                    'engad',
                    summary.total ? summary.total.engad.p : 0
                  )
                "
                v-on:mouseout="textClear()"
                :class="
                  `rango${rangos(summary.total ? summary.total.engad.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h2 class="w-full">Engagement</h2>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="20"
                    :h="20"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="engad"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
            <td class="is-size-6 has-text-centered is-hidden-mobile">
              <div
                v-on:mouseover="
                  textInter(
                    'dimenc',
                    'recd',
                    summary.total ? summary.total.recd.p : 0
                  )
                "
                v-on:mouseout="textClear()"
                :class="
                  `rango${rangos(summary.total ? summary.total.recd.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h2 class="w-full">Recursos</h2>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="20"
                    :h="20"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="recd"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
            <td class="is-size-6 has-text-centered is-hidden-mobile">
              <div
                v-on:mouseover="
                  textInter(
                    'dimenc',
                    'compd',
                    summary.total ? summary.total.compd.p : 0
                  )
                "
                v-on:mouseout="textClear()"
                :class="
                  `rango${rangos(summary.total ? summary.total.compd.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h2 class="w-full">Compensación</h2>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="20"
                    :h="20"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="compd"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
            <!--      Mobile      -->
            <td
              colspan="2"
              class="is-size-6 has-text-centered is-hidden-desktop"
            >
              <div
                v-on:mouseover="
                  textInter(
                    'dimenc',
                    'lidd',
                    summary.total ? summary.total.lidd.p : 0
                  )
                "
                v-on:mouseout="textClear()"
                :class="
                  `rango${rangos(summary.total ? summary.total.lidd.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h2 class="w-full">Liderazgo</h2>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="20"
                    :h="20"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="lidd"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
            <td
              colspan="2"
              class="is-size-6 has-text-centered is-hidden-desktop"
            >
              <div
                v-on:mouseover="
                  textInter(
                    'dimenc',
                    'engad',
                    summary.total ? summary.total.engad.p : 0
                  )
                "
                v-on:mouseout="textClear()"
                :class="
                  `rango${rangos(summary.total ? summary.total.engad.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h2 class="w-full">Engagement</h2>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="20"
                    :h="20"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="engad"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
          </tr>
          <!--     Mobile     -->
          <tr>
            <td
              colspan="2"
              class="is-size-6 has-text-centered is-hidden-desktop"
            >
              <div
                v-on:mouseover="
                  textInter(
                    'dimenc',
                    'recd',
                    summary.total ? summary.total.recd.p : 0
                  )
                "
                v-on:mouseout="textClear()"
                :class="
                  `rango${rangos(summary.total ? summary.total.recd.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h2 class="w-full">Recursos</h2>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="20"
                    :h="20"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="recd"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
            <td
              colspan="2"
              class="is-size-6 has-text-centered is-hidden-desktop"
            >
              <div
                v-on:mouseover="
                  textInter(
                    'dimenc',
                    'compd',
                    summary.total ? summary.total.compd.p : 0
                  )
                "
                v-on:mouseout="textClear()"
                :class="
                  `rango${rangos(summary.total ? summary.total.compd.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <div></div>
                  <h2 class="w-full">Compensación</h2>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="20"
                    :h="20"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="compd"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <!-- General Ctx -->
      <div
        class="column"
        :class="generalContext.status ? 'is-6' : ''"
        style="padding: 1.5rem;"
      >
        <transition name="fade">
          <div
            class="content-ctx"
            v-if="generalContext && generalContext.status"
          >
            <div>
              <span class="titleCtx">
                Benchmark
              </span>
              <div class="headerKpiCtx">
                <div class="ranking">
                  <img
                    src="@/assets/icons/ranking-linear.svg"
                    alt="rankingIconCL7"
                    width="70"
                  />
                  <div class="info">
                    <span class="title-ranking">{{
                      generalContext.headers.position
                    }}</span>
                    <span
                      v-tooltip.bottom="
                        'Posición actual frente al total de empresas'
                      "
                      class="subtitle-ranking"
                    >
                      Entre
                      <strong>{{ generalContext.headers.clients || 0 }}</strong>
                      Empresas
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <span class="subtitleCtx">
              Distribución de empresas en
              <strong>Clima total</strong>
            </span>
            <div>
              <GraphChartJs :config="createdLineContext('CClimad')" />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import GraphChartJs from "../dashboard/GraphChartJs.vue";
import directionIndicator from "./components/directionIndicator.vue";
import json from "./interpretaciones.json";

export default {
  data() {
    return {
      summary: {},
      nombrerangos: {
        1: "Sigamos así",
        2: "Vamos bien",
        3: "Cuidado",
        4: "Necesita atención pronto",
        5: "Actuemos ya",
        0: "N/A",
      },
      calificaciones: json,
    };
  },
  props: {
    proceso: {
      type: Object,
    },
    summaryTotal: {
      type: Object,
      required: true,
    },
    generalContext: {
      type: Object,
      required: true,
    },
    createdLineContext: Function,
  },
  beforeMount() {
    this.summary = this.summaryTotal;
  },
  methods: {
    textClear() {
      if (this.generalContext.status) return true;
      let b = document.getElementById("bodyInterAct");
      let t = document.getElementById("titleInterAct");
      let p = document.getElementById("textInterAct");

      b.style.padding = "0";
      p.innerHTML = "";
      t.innerHTML = "";
    },
    textInter(group, subGroup, value) {
      if (this.generalContext.status) return true;
      let dato = this.calificaciones[group].dimensiones[subGroup];
      let txt = dato.rango[this.rangos(value)].inter;
      let title = dato.title;

      let b = document.getElementById("bodyInterAct");
      let t = document.getElementById("titleInterAct");
      let p = document.getElementById("textInterAct");

      b.style.padding = "1.25rem";
      p.innerHTML = txt;
      t.innerHTML = title + "  " + value.toFixed(1) + "%";
    },
    rangos(n) {
      let returned;
      if (n === 0) {
        returned = 5;
      } else if (isNaN(n)) {
        returned = 0;
      } else if (n >= 84) {
        // Mayor o igual a 84
        returned = 1;
      } else if (n >= 70 && n <= 83.9) {
        // Mayor o igual a 70 y Menor o igual 83.9
        returned = 2;
      } else if (n >= 30 && n <= 69.9) {
        // Mayor o igual a 30 y Menor o igual 69.9
        returned = 3;
      } else if (n >= 16 && n <= 29.9) {
        // Mayor o igual a 16 y Menor o igual 29.9
        returned = 4;
      } else {
        returned = 5;
      }
      return returned;
    },
  },
  components: {
    directionIndicator,
    GraphChartJs,
  },
};
</script>

<style scoped lang="scss">
.w-full {
  width: 100%;
}

.widthTooltip {
  width: 50px !important;
}

.rango1 {
  background-color: #76be7c !important;
  color: white !important;
}

.rango2 {
  background-color: #d9ead3 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango3 {
  background-color: #fde8af !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango4 {
  background-color: #f5bc95 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango5 {
  background-color: #fda0a0 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango0 {
  background-color: #a5a5a5;
}

.table-general h1 {
  padding: 1.5rem;
}

.table-general h2 {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}

.table-general td {
  padding: 0.5rem;
}

.table-general td div {
  border-radius: 5px;
}

.content-ctx {
  gap: 20px;
  display: flex;
  max-height: 375px;
  padding: 20px;
  border-radius: 6px;
  flex-direction: column;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}

.titleCtx {
  padding: 5px 0;
  border-radius: 16px;
  font-size: 18px;
  font-weight: bolder;
  color: #7647ae;
}

.subtitleCtx {
  text-align: left;
}

.headerKpiCtx {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.ranking {
  gap: 15px;
  display: flex;
  margin: 10px 0;
  border-radius: 6px;
  justify-content: start;
}

.ranking .info {
  display: flex;
  flex-direction: column;
}

.ranking .title-ranking {
  color: #363636;
  text-align: center;
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.125;
}
.ranking .subtitle-ranking {
  line-height: normal;
}

.p-2 {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/ResultadosGeneral.vue